import { render, staticRenderFns } from "./CourseLectureTree.vue?vue&type=template&id=dff890ca&scoped=true&"
import script from "./CourseLectureTree.vue?vue&type=script&lang=ts&"
export * from "./CourseLectureTree.vue?vue&type=script&lang=ts&"
import style0 from "./CourseLectureTree.vue?vue&type=style&index=0&id=dff890ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff890ca",
  null
  
)

export default component.exports